import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If user is already authenticated, redirect to appropriate page
  if (authService.isAuthenticated()) {
    const user = authService.getCurrentUser();
    if (user) {
      if (user.userType === 'Supplier') {
        router.navigate(['/leads'], { replaceUrl: true });
      } else {
        // Admin/Manager
        router.navigate(['/product'], { replaceUrl: true });
      }
    } else {
      router.navigate(['/product'], { replaceUrl: true });
    }
    return false;
  }
  
  // If not authenticated, allow access to login page
  return true;
};

